module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_troms_og_finnmark_neg.ce0ea602.svg";